export const defaultFontFamily = ['IBM Plex Sans', 'sans-serif'].join(',');
